import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  padding: 2rem;

  background: #fff;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;

  @media (min-width: 600px) {
    border-bottom-left-radius: 0;
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }
`;
